import React, { PureComponent } from "react";

class SelectWithLabel extends PureComponent {

   render() {

    const { mensajeError, options, seleccionarCombo, value, nombreCombo, titulo, disabled, short } = this.props;
    
    return (
     <div className= "row" >
       <div className="col-xs-12">
          <label className="label-primary">{titulo}</label>
          <select
            style={{maxWidth: short ? "29%" : "100%"}}
            disabled={disabled}
             value={value}
             className="form-control default-select"
             onChange={(event) => {
                let index = event.target.selectedIndex;
                let optionActual = event.target.options[index];
                seleccionarCombo(event.target.value, nombreCombo, optionActual.dataset.codigo, optionActual.innerText)
             }}
          >
            <option value="0">Seleccione...</option>
            {options}
         </select>
        </div>
        <div className="col-xs-12">
          <label className="error">{mensajeError}</label>
        </div>

    </div>
    );
   }
}

export default SelectWithLabel;